/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img[_ngcontent-%COMP%]{height:22px;width:22px;margin-right:10px}a[_ngcontent-%COMP%]{width:204px}a[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]{pointer-events:none;cursor:default}@media (max-width:599px){a[_ngcontent-%COMP%]{padding-left:0}}"];
export { styles as styles };
